<template>
  <el-card class="no-padding-header">
    <div slot="header" class="clearfix intelipost">
      <img src="/img/integration/logo-intelipost.jpg" class="integration-image" />
    </div>
    <el-form :model="ruleForm">
      <el-form-item prop="active">
        <el-checkbox v-model="ruleForm.active">Habilitar Webhook SRO</el-checkbox>
      </el-form-item>
      <el-form-item label="Token" prop="token">
        <el-col :xs="24">
          <el-input :disabled="!ruleForm.active" v-model="ruleForm.token"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="Base URL" prop="baseUrl">
        <el-col :xs="24">
          <el-input :disabled="!ruleForm.active" v-model="ruleForm.baseUrl"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="CNPJ" prop="cnpj">
        <el-col :xs="24">
          <el-input :disabled="!ruleForm.active" v-model="ruleForm.cnpj"></el-input>
        </el-col>
      </el-form-item>
    </el-form>
  </el-card>
</template>
<script>
export default {
  name: "IntelipostComponent",
  data() {
    return {
      ruleForm: {
        token: "",
        baseUrl: "https://api.intelipost.com.br/api/v1",
        cnpj: "",
        active: false,
      }
    }
  },
  methods: {
    get() {
      return this.ruleForm;
    },
    setup(data) {
      const webhooks = this.parseWebhooks(data);
      if (!webhooks.intelipost) return;

      this.ruleForm.token = webhooks.intelipost.token || webhooks.intelipost["txt-token"] || "";
      this.ruleForm.baseUrl = webhooks.intelipost.baseUrl || webhooks.intelipost.base_url || webhooks.intelipost["txt-base-url"] || "https://api.intelipost.com.br/api/v1";
      this.ruleForm.cnpj = webhooks.intelipost.cnpj || webhooks.intelipost["txt-cnpj"] || "";
      this.ruleForm.active = webhooks.intelipost.active;
    },
    parseWebhooks(data) {
      if (!data || !data.webhooks) return {};
      if (typeof data.webhooks === "object") return data.webhooks;
      try {
        return JSON.parse(data.webhooks);
      } catch (error) {
        return {};
      }
    }
  }
};
</script>
<style>
.intelipost {
  width: 100%;
  background-color: #ffffff;
  text-align: center;
}
.intelipost .integration-image {
  max-width: 100%;
  max-height: 70px;
  object-fit: contain;
}
.no-padding-header .el-card__header {
  padding: 0;
}
</style>
